var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("span", {
    class: [_vm.$style["mds-icon"], _vm.sizeClass],
    attrs: {
      "aria-hidden": "true",
      "data-mds-version": _vm.version,
      "data-mds-icon-name": _vm.name,
    },
    domProps: { innerHTML: _vm._s(_vm.svgIcon) },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }